import { Box, Grid, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import Card from '../components/Card';
import RocketIcon from 'assets/img/icons/RocketIcon';
import CloseIcon from 'assets/img/icons/CloseIcon';

interface WelcomeNoticeProps {
  onHide?: () => void;
}

const WelcomeNotice: React.FC<WelcomeNoticeProps> = ({ onHide }) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  const textStyles = {
    fontSize: { desktop: '20px', tablet: '20px', mobile: '16px' },
    color: 'black',
  };

  const Header: React.FC = () => (
    <Stack width="100%" justifyContent="space-between" flexDirection="row">
      <Stack flexDirection="row" sx={{ gap: { desktop: 3, tablet: 3, mobile: '12px' } }}>
        <Box
          sx={{
            width: { desktop: '48px', tablet: '48px', mobile: '40px' },
            height: { desktop: '48px', tablet: '48px', mobile: '40px' },
            backgroundColor: '#ffffff',
            border: '1px solid #F1F2FB',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <RocketIcon />
        </Box>

        <Typography fontWeight="500" sx={{ fontSize: textStyles.fontSize, alignSelf: 'center' }}>
          Welcome to Factiverse!
        </Typography>
      </Stack>
      <Stack flexDirection="row" alignItems="center" gap={1}>
        {!isMobileScreen && (
          <Typography fontWeight="400" sx={{ fontSize: '16px', color: '#6C727A' }}>
            Hide post
          </Typography>
        )}
        <IconButton sx={{ width: '40px', height: '40px' }} onClick={onHide}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </Stack>
  );

  const Description: React.FC = () => (
    <Stack
      direction="column"
      alignItems="flex-start"
      mb={2}
      sx={{
        mr: { desktop: 14, tablet: 8, mobile: 1 },
        mt: { desktop: 3, tablet: 3, mobile: 2 },
        gap: { desktop: 3, tablet: 3, mobile: 2 },
      }}
      width="100%"
    >
      <Typography sx={{ fontSize: '16px' }}>
        Before signing up or logging in, you can explore suggested claims at the bottom of the page.
        To write your own claims, you need to sign up or log in — and the best part is, our platform
        is free to use!
      </Typography>
      <Typography sx={{ fontSize: '16px' }}>Thank you 👍</Typography>
    </Stack>
  );

  return (
    <Card
      sx={{
        paddingX: { mobile: '16px', tablet: '30px', desktop: '30px' },
        paddingY: { mobile: '16px', tablet: '30px', desktop: '30px' },
        mb: 3,
      }}
    >
      <Grid container>
        <Header />
        <Description />
      </Grid>
    </Card>
  );
};

export default WelcomeNotice;
